import React from "react";
import { formatDateCell } from "../../shared/utils/dateDisplay";
import {
  formatStockSignedPercent,
  signedPercentClassName,
} from "../../shared/utils/stockPercentFormat";
import {
  STOCK_NUMERIC_FIELDS,
  STOCK_PCT_FIELDS,
  formatStockCurrency,
  formatStockMarketCapBillions,
  formatStockNumber,
} from "../../shared/utils/stockHoldingsTable";

/**
 * Render one Holdings table cell (Holdings + ARK ETF tabs).
 * @param {{ colId: string, row: object, onSymbolClick?: (row: object) => void }} props
 */
export default function StockHoldingsTableCell({ colId, row, onSymbolClick }) {
  switch (colId) {
    case "symbol": {
      const label = row.symbol || "—";
      const canOpen = Boolean(onSymbolClick && row.stock_id);
      if (canOpen) {
        return (
          <button type="button" className="btn-link" onClick={() => onSymbolClick(row)}>
            {label}
          </button>
        );
      }
      return label;
    }
    case "name":
      return row.name || "—";
    case "trade_date": {
      const raw = row.trade_date != null ? String(row.trade_date).trim() : "";
      if (!raw) return "—";
      const parsed = formatDateCell(raw);
      return parsed !== "—" ? parsed : raw;
    }
    case "ark_market_value":
    case "ark_trade_market_value":
      return row[colId] ? String(row[colId]) : "—";
    case "ark_weight":
      return row.ark_weight ? String(row.ark_weight) : "—";
    case "earnings_date":
      return formatDateCell(row.earnings_date);
    case "analyst_rating":
    case "sector":
    case "industry":
      return row[colId] ? String(row[colId]) : "—";
    case "market_cap":
      return formatStockMarketCapBillions(row.market_cap);
    case "equity":
      return formatStockCurrency(row.equity);
    default:
      if (STOCK_PCT_FIELDS.has(colId)) {
        const showPlus = colId !== "short_float";
        const { text, tone } = formatStockSignedPercent(row[colId], { showPlus });
        if (tone === "empty") return text;
        return <span className={signedPercentClassName(tone)}>{text}</span>;
      }
      if (STOCK_NUMERIC_FIELDS.includes(colId)) return formatStockNumber(row[colId]);
      return "—";
  }
}
